module.exports = __webpack_public_path__ + "static/breakfast-910bb34b88dc5ee97d0121020dcb6179.jpg";